export default function PersonalityHobColumn({ children }) {
  return (
    <div className="hobbies-info-list">
      <div className="hobbies-list">{children}</div>
    </div>
  );
}
